import { produce } from "immer";

import type { FrameActions } from "./actions";

export interface INavItem {
  href: string;
  id: string;
  parent_id?: string;
  sort_order?: number;
  enabled?: boolean;
  disable_icon?: boolean;
  title: string;
  icon?: string;
  children: string[];
  sectionTitle?: string;
  sectionDivider?: boolean;
  divided?: boolean;
  hidden?: boolean;
  beta?: boolean;
}

export interface IFrameState {
  nav: {
    itemsById: Record<string, INavItem>;
    rootIds: string[];
    expanded: boolean;
  };
  darkMode: boolean | undefined;
}

const initialState: IFrameState = {
  nav: {
    itemsById: {},
    rootIds: [],
    expanded: true,
  },
  darkMode: undefined,
};

export const frameReducer = produce((draft: IFrameState, action: FrameActions) => {
  switch (action.type) {
    case "REGISTER_NAV_ITEM": {
      draft.nav.itemsById[action.payload.id] = {
        ...action.payload,
        children: [],
        enabled: action.payload.enabled !== undefined ? action.payload.enabled : true,
      };
      // Normalize
      for (const id of Object.keys(draft.nav.itemsById)) {
        const childIds = Object.entries(draft.nav.itemsById)
          .filter(([, item]) => item.parent_id === id)
          .map(([x]) => x);

        draft.nav.itemsById[id].children = childIds;
      }

      draft.nav.rootIds = Object.entries(draft.nav.itemsById)
        .filter(([, item]) => !item.parent_id)
        .map(([id]) => id);
      break;
    }
    case "SET_NAV_EXPANDED": {
      draft.nav.expanded = action.payload;
      break;
    }
    case "SET_DARK_MODE": {
      draft.darkMode = action.payload;
      break;
    }
    default:
      break;
  }
}, initialState);
